import { FC, SVGProps } from "react";

const BaggageIcon: FC<SVGProps<SVGSVGElement>> = (props) => {
  return (
    <svg viewBox="0 0 512 512" fill="currentcolor" {...props}>
      <path
        d="M389.742,77.553H329.99V30.417h15.146V0H166.865v30.417h15.146v47.135h-59.752c-19.059,0-34.566,15.506-34.566,34.566
			V438.41c0,19.059,15.506,34.566,34.566,34.566h26.268V512h30.417v-39.024h154.114V512h30.417v-39.024h26.268
			c19.059,0,34.566-15.506,34.566-34.566V112.119C424.308,93.058,408.802,77.553,389.742,77.553z M212.426,30.417h87.146v47.135
			h-87.146V30.417z M393.891,438.41c0,2.287-1.861,4.149-4.149,4.149H122.258c-2.287,0-4.149-1.861-4.149-4.149V112.119
			c0-2.287,1.861-4.149,4.149-4.149h267.484c2.287,0,4.149,1.861,4.149,4.149V438.41z"
      />
      <rect x="148.933" y="229.639" width="30.417" height="178.447" />
      <rect x="210.172" y="229.639" width="30.417" height="178.447" />
      <rect x="271.412" y="229.639" width="30.417" height="178.447" />
      <rect x="332.652" y="229.639" width="30.417" height="178.447" />
      <path d="M179.957,128.908v76.711h152.086v-76.711H179.957z M301.626,175.202h-91.252v-15.877h91.252V175.202z" />
    </svg>
  );
};

export default BaggageIcon;
